import { Directive } from '@angular/core';

@Directive({
  selector: '[snPlayerPtz]',
  host: {
    class: 'sn-player__ptz',
  },
})
export class SnPlayerPtzDirective {
  constructor() {}
}
